<p-dialog class="add-fee-main" [header]='setLabel("addFeeHeaderLabel")' [closeOnEscape]="true" [focusOnShow]="false"
    [(visible)]="feeInvoiceDialog" (onHide)="dialogClose()">
    <form #feeForm="ngForm" style="width: 770px;height: 255px !important;">
        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("package:Label")}}</span>
                <span class="add-fee-main-value">{{ packageName }}</span>
            </div>
        </div>

        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("noOfMembers:Label")}}</span>
                <span class="add-fee-main-value">{{ noOfMembers }}</span>
            </div>
        </div>

        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("packageFeeLabel")}} ( {{packageFeeLabel}} )</span>
                <div class="add-fee-main-value">
                    <div class="add-fee-main-value-box">
                        <input type="number" id="totalFeePackage" #totalFeePackage required pattern="[0-9]+"
                            autocomplete="off" pInputText [placeholder]='setLabel("packageFeePlaceholderLabel")'
                            name="fundPay" [(ngModel)]="totalPackageFee" #fundPay="ngModel" [ngClass]="fundPay.invalid && (fundPay.dirty ||
                            fundPay.touched)
                            ? 'errorInput'
                            : ''" (ngModelChange)="onTotalPackageFeeChange()" />
                        <span class="p-inputgroup-addon">.00</span>
                    </div>
                    <div *ngIf="fundPay.invalid && (fundPay.dirty || fundPay.touched)"
                        style="text-align: right; margin-right: 31px;">
                        <div *ngIf="fundPay.errors.required" class="errorShow">
                            {{setLabel("packageFeeErrorLabel")}}
                        </div>
                        <div *ngIf="fundPay.errors.pattern" class="errorShow">
                            {{setLabel("feeCorrectlyErrorLabel")}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("packageDiscountLabel")}}</span>
                <div class="add-fee-main-value">
                    <div class="add-fee-main-value-box">
                        <input type="number" id="discount" pattern="[0-9]+" autocomplete="off" pInputText
                            [placeholder]='setLabel("packageFeeDiscountPlaceholderLabel")' name="PackageFeeDiscount"
                            [(ngModel)]="monthlyDiscount" #PackageFeeDiscount="ngModel"
                            (ngModelChange)="checkPackageDiscount()" />
                        <span class="p-inputgroup-addon">.00</span>
                    </div>
                    <div *ngIf="discountExceedsFee" style="text-align: right; margin-right: 31px; color: red;">
                        {{setLabel("packageDiscounExceedErrorLabel")}}
                    </div>
                </div>
            </div>
        </div>

        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("totalMonthlyFee:Label")}}</span>
                <span class="add-fee-main-value infoStyle">
                    {{monthlyFeeCalculationEquation}}
                    <br />
                    <i *ngIf="taxType === 'INCLUDING_TAX'" class="taxLabel">{{taxOnMonthlyFee}}
                        {{setLabel("taxIncludedErrorLabel")}}</i>
                </span>
            </div>
        </div>
        <!-- <div class="p-g-12 p-md-12">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon" style="width: 43%;">Received Fee </span>
                <input type="number" id="receivedFeePackage" style="width: 100% !important" required pattern="[0-9]+" autocomplete="off"
                    pInputText placeholder="Received Monthly Fee" name="fundReceivePay" [(ngModel)]="totalReceivedFee" #fundReceivePay="ngModel"
                    [ngClass]="fundReceivePay.invalid && (fundReceivePay.dirty ||
                    fundReceivePay.touched)
                    ? 'errorInput'
                    : ''" />
                <span class="p-inputgroup-addon">.00</span>
            </div>

            <div style="text-align: right; margin-right: 31px;">
                <div *ngIf="fundReceivePay.value > totalFee " class="errorShow">
                    Received Fee Must be less than Actual Package Fee.
                </div>
            </div>

            <div *ngIf="fundReceivePay.invalid && (fundReceivePay.dirty || fundReceivePay.touched)" style="text-align: right; margin-right: 31px;">
                <div *ngIf="fundReceivePay.errors.required" class="errorShow">
                    Please Enter Received Fee.
                </div>
                <div *ngIf="fundReceivePay.errors.pattern" class="errorShow">
                    Please Enter Fee Correctly.
                </div>
            </div>
        </div> -->

        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("registrationFeeLabel")}} ({{regFeeLabel}})</span>
                <div class="add-fee-main-value">
                    <div class="add-fee-main-value-box">
                        <input style="width: 60% !important;" type="number" id="registrationFeePackage" required
                            pattern="[0-9]+" autocomplete="off" pInputText
                            [placeholder]='setLabel("registrationFeePlaceholderLabel")' name="registerationFee"
                            [(ngModel)]="totalRegistrationPackageFee" #registerationFee="ngModel" [ngClass]="registerationFee.invalid
                            &&
                            (registerationFee.dirty || registerationFee.touched)
                            ? 'errorInput'
                            : ''" (ngModelChange)="onTotalRegistrationFeeChange()" />
                        <span class="p-inputgroup-addon">.00</span>
                    </div>
                    <div *ngIf="registerationFee.invalid &&
                        (registerationFee.dirty || registerationFee.touched)"
                        style="text-align: right; margin-right: 31px;">
                        <div *ngIf="fundPay.errors.required" class="errorShow">
                            {{setLabel("regFeeErrorLabel")}}
                        </div>
                        <div *ngIf="registerationFee.errors.pattern" class="errorShow">
                            {{setLabel("regFeeCorrectlyErrorLabel")}}
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("registrationDiscountLabel")}}</span>
                <div class="add-fee-main-value">
                    <div class="add-fee-main-value-box">
                        <input style="width: 60% !important;" type="number" id="registrationDiscount" pattern="[0-9]+"
                            autocomplete="off" pInputText
                            [placeholder]='setLabel("registrationFeeDiscountPlaceholderLabel")'
                            name="registerationFeeDiscount" [(ngModel)]="registrationDiscount"
                            #registerationFeeDiscount="ngModel" (ngModelChange)="checkRegistrationDiscount()" />
                        <span class="p-inputgroup-addon">.00</span>
                    </div>
                    <div *ngIf="discountExceedsRegistrationFee"
                        style="text-align: right; margin-right: 31px; color: red;">
                        {{setLabel("registrationDiscountExceedRegistrationFeeErrorLabel")}}
                    </div>
                </div>
            </div>
        </div>
        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("totalRegistrationFee:Label")}}</span>
                <span class="add-fee-main-value infoStyle">
                    {{registrationFeeCalculationEquation}}
                    <br />
                    <i *ngIf="taxType === 'INCLUDING_TAX'" class="taxLabel">{{taxOnRegistration}}
                        {{setLabel("taxIncludedRegistrationErrorLabel")}}</i>
                </span>
            </div>
        </div>


        <div class="p-g-12 p-md-12" *ngIf="totalTrainerFee!=0">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("trainerFee:Label")}}</span>
                <div class="add-fee-main-value">
                    <div class="add-fee-main-value-box">
                        <input type="number" id="trainerFeePackage" required pattern="[0-9]+" autocomplete="off"
                            pInputText [placeholder]='setLabel("trainerFeePlaceholderLabel")' readonly
                            name="totalTrainerFee" [(ngModel)]="totalTrainerFee" #trainerFee="ngModel" [ngClass]="trainerFee.invalid &&
                            (trainerFee.dirty || trainerFee.touched)
                            ? 'errorInput'
                            : ''" />
                        <span class="p-inputgroup-addon">.00</span>
                    </div>
                    <div *ngIf="trainerFee.invalid &&
                        (trainerFee.dirty || trainerFee.touched)" style="text-align: right; margin-right: 31px;">
                        <div *ngIf="trainerFee.errors.required" class="errorShow">
                            {{setLabel("trainerFeeErrorLabel")}}
                        </div>
                        <div *ngIf="trainerFee.errors.pattern" class="errorShow">
                            {{setLabel("trainerFeeCorrectlyErrorLabel")}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-g-12 p-md-12" *ngIf="totalTrainerFee!=0">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("trainerDiscountLabel")}}</span>
                <div class="add-fee-main-value">
                    <div class="add-fee-main-value-box">
                        <input style="width: 60% !important;" type="number" id="trainerDiscount" pattern="[0-9]+"
                            autocomplete="off" pInputText [placeholder]='setLabel("trainerFeeDiscountPlaceholderLabel")'
                            name="trainerFeeDiscount" [(ngModel)]="trainerDiscount" #registerationFeeDiscount="ngModel"
                            (ngModelChange)="checkTrainerDiscount()" />
                        <span class="p-inputgroup-addon">.00</span>
                    </div>
                    <div *ngIf="trainerDiscountExceeds" style="text-align: right; margin-right: 31px; color: red;">
                        {{setLabel("exceedTrainerFeeErrorLabel")}}
                    </div>
                </div>
            </div>
        </div>
        <div class="p-g-12 p-md-12" *ngIf="totalTrainerFee!=0">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("totalTrainerFee:Label")}}</span>
                <span class="add-fee-main-value infoStyle">
                    {{ trainerFeeCalculationEquation }}
                    <br />
                    <i *ngIf="taxType === 'INCLUDING_TAX'" class="taxLabel">{{taxOnTrainerFee}}
                        {{setLabel("taxIncludedTrainerErrorLabel")}}</i>
                </span>
            </div>
        </div>
        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("grandTotal:Label")}}</span>
                <span class="add-fee-main-value infoStyle">
                    {{ grandTotalCalculationEquation }}
                    <br />
                    <i *ngIf="taxType === 'INCLUDING_TAX'" class="taxLabel">
                        Total of {{taxOnMonthlyFee+taxOnRegistration+taxOnTrainerFee}}
                        {{setLabel("taxIncludedFeeErrorLabel")}}
                    </i>
                </span>
            </div>
        </div>

        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("nextDueDate:Label")}}</span>
                <span class="add-fee-main-value">
                    {{dueDate}}
                </span>
            </div>
        </div>
        <div class="p-g-12 p-md-12" *ngIf="onlineMembers.length > 1">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("selectMemberForOnlinePayment:Label")}}</span>
                <div class="add-fee-main-value">
                    <p-dropdown [options]="onlineMembers" [(ngModel)]="selectedMemberId" name="selectedMemberId"
                        optionLabel="name" [placeholder]='setLabel("selectAMemberPlaceholderLabel")'
                        required></p-dropdown>
                    <br>
                </div>
            </div>
        </div>
        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("modeOfPaymentLabel")}}</span>
                <div class="add-fee-main-value">
                    <p-dropdown class="p-g-8" [options]="paymentOptions"
                        (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
                    <!-- Adjust the width and styling as needed -->
                    <span class="p-g-1"></span>
                </div>
            </div>
            <div class="add-fee-main-block"
                *ngIf="paymentMode && paymentMode.includes('Online-') || paymentMode && paymentMode.includes('Check-')">
                <span class="add-fee-main-Label">&nbsp;</span>
                <div class="add-fee-main-value">
                    <button pButton class="p-button-success" [pTooltip]='setLabel("uploadReceiptTooltipLabel")'
                        tooltipPosition="top" (click)="onUploadButtonClick()">
                        <span class="p-button-text p-c">
                            <i class="fa fa-upload" aria-hidden="true"></i>
                            &nbsp;{{setLabel("uploadReceiptBtnLabel")}}
                        </span>
                    </button>
                    <input id="fileInput" type="file" style="display: none" (change)="fileChangeEvent($event)">
                    <div *ngIf="selectedFileName">
                        {{setLabel("selectedFile:Label")}} {{ selectedFileName }}
                    </div>
                </div>
            </div>

        </div>
        <div class="p-g-12 p-md-12">
            <div class="add-fee-main-block">
                <span class="add-fee-main-Label">{{setLabel("commentLabel")}}</span>
                <div class="add-fee-main-value">
                    <textarea class="p-g-8" style="width: 100% !important;" rows="5" cols="50" [(ngModel)]="description"
                        name="description" pInputTextarea></textarea>
                    <span class="p-g-1"></span>
                </div>
            </div>
        </div>

        <p-footer>
            <button (click)="registrationPayment()" id="registrationPayment"
                style="float: right !important; margin-right: 42px !important;" [disabled]="!feeForm.valid" pButton
                type="button" [label]='setLabel("onlineLabel")' icon="pi pi-save" class="p-button-success"></button>

            <button *ngIf="paymentMode && paymentMode.includes('Online-') || paymentMode && paymentMode.includes('Check-')" [disabled]="selectedFileName == undefined"  (click)="addFee()" id="feeSaveButton"
                style="float: right !important; margin-right: 42px !important;" pButton type="button"
                [label]='setLabel("saveLabel")' icon="pi pi-save" class="p-button-success"></button>

                <button *ngIf="paymentMode && paymentMode.includes('Cash-') || paymentMode && paymentMode.includes('Credit/Debit-')" (click)="addFee()"  id="feeSaveButton"
                    style="float: right !important; margin-right: 42px !important;" pButton type="button"
                    [label]='setLabel("saveLabel")' icon="pi pi-save" class="p-button-success"></button>
        </p-footer>
    </form>
</p-dialog>






<!-- <p-dialog header="Add Fee" [closeOnEscape]="true" [(visible)]="feeInvoiceDialog" (onHide)="dialogClose()">
    <form #feeForm="ngForm" style="height: 250px; width: 570px">

        <div style="display: flex !important;">
            <div class="p-g-10 p-md-10">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">Package Fee </span>
                    <input type="number" style="width: 35% !important" required pattern="[0-9]+" autocomplete="off"
                        pInputText placeholder="Price" name="fundPay" [(ngModel)]="totalPackageFee" #fundPay="ngModel"
                        [ngClass]="fundPay.invalid && (fundPay.dirty ||
                        fundPay.touched)
                        ? 'errorInput'
                        : ''" />
                    <span class="p-inputgroup-addon">.00</span>
                </div>
            </div>

            <div class="p-g-12 p-md-12">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">Received Montly Fee </span>
                    <input type="number" style="width: 30% !important" required pattern="[0-9]+" autocomplete="off"
                        pInputText placeholder="Price" name="fundReceivePay" [(ngModel)]="totalReceivedFee" #fundReceivePay="ngModel"
                        [ngClass]="fundReceivePay.invalid && (fundReceivePay.dirty ||
                        fundReceivePay.touched)
                        ? 'errorInput'
                        : ''" />
                    <span class="p-inputgroup-addon">.00</span>
                </div>
            </div>
        </div>

        <div style="display: flex !important;">
            <div class="p-g-10 p-md-10">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" style="width: 42% !important; text-align: left !important;">Trainer Fee </span>
                    <input type="number" style="width: 35% !important" required pattern="[0-9]+" autocomplete="off"
                        pInputText placeholder="Price" readonly name="totalTrainerFee" [(ngModel)]="totalTrainerFee"
                        #trainerFee="ngModel" [ngClass]="trainerFee.invalid &&
                        (trainerFee.dirty || trainerFee.touched)
                        ? 'errorInput'
                        : ''" />
                <span class="p-inputgroup-addon">.00</span>
                </div>
            </div>

            <div class="p-g-12 p-md-12">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon" style="width: 52% !important; text-align: center;">Registration Fee</span>
                    <input type="number" style="width: 30% !important" required pattern="[0-9]+" autocomplete="off"
                        pInputText placeholder="Price" name="registerationFee"
                        [(ngModel)]="totalRegistrationPackageFee" #registerationFee="ngModel" [ngClass]="registerationFee.invalid
                        &&
                        (registerationFee.dirty || registerationFee.touched)
                        ? 'errorInput'
                        : ''" />
                <span class="p-inputgroup-addon">.00</span>
                </div>
            </div>
        </div>

        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup"></div>
        </div>

        <p-footer>
            <button (click)="addFee()" style="float: right !important; margin-right: 42px !important;"
                [disabled]="!feeForm.valid" pButton type="button" label="Save" icon="pi pi-save"
                class="p-button-success"></button>
        </p-footer>
    </form>
</p-dialog> -->
<!-- <p-dialog header="Add Fee" [closeOnEscape]="true" [(visible)]="feeInvoiceDialog" (onHide)="dialogClose()">
    <form #feeForm="ngForm" style="height: 250px; width: 570px">

        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">Package Fee </span>
                <input type="number" style="width: 100% !important" required pattern="[0-9]+" autocomplete="off"
                    pInputText placeholder="Price" name="fundPay" [(ngModel)]="totalPackageFee" #fundPay="ngModel"
                    [ngClass]="fundPay.invalid && (fundPay.dirty ||
                    fundPay.touched)
                    ? 'errorInput'
                    : ''" />
                <span class="p-inputgroup-addon">.00</span>
            </div>

        </div>

        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">Received Montly Fee </span>
                <input type="number" style="width: 100% !important" required pattern="[0-9]+" autocomplete="off"
                    pInputText placeholder="Price" name="fundReceivePay" [(ngModel)]="totalReceivedFee" #fundReceivePay="ngModel"
                    [ngClass]="fundReceivePay.invalid && (fundReceivePay.dirty ||
                    fundReceivePay.touched)
                    ? 'errorInput'
                    : ''" />
                <span class="p-inputgroup-addon">.00</span>
            </div>
            <div *ngIf="fundReceivePay.invalid && (fundReceivePay.dirty || fundReceivePay.touched)">
                <div *ngIf="fundReceivePay.errors.required" class="errorShow">
                    Please Enter Fee Correctly.
                </div>
                <div *ngIf="fundReceivePay.errors.pattern" class="errorShow">
                    Please Enter Fee Correctly.
                </div>
            </div>
        </div>

        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">Registration Fee </span>
                <input type="number" style="width: 100% !important" required pattern="[0-9]+" autocomplete="off"
                    pInputText placeholder="Price" name="registerationFee"
                    [(ngModel)]="totalRegistrationPackageFee" #registerationFee="ngModel" [ngClass]="registerationFee.invalid
                    &&
                    (registerationFee.dirty || registerationFee.touched)
                    ? 'errorInput'
                    : ''" />
                <span class="p-inputgroup-addon">.00</span>
            </div>
            <div *ngIf="registerationFee.invalid &&
                (registerationFee.dirty || registerationFee.touched)">
                <div *ngIf="fundPay.errors.required" class="errorShow">
                    Please Enter Reg.Fee Correctly.
                </div>
                <div *ngIf="registerationFee.errors.pattern" class="errorShow">
                    Please Enter Reg.Fee Correctly.
                </div>
            </div>
        </div>

        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup">
                <span class="p-inputgroup-addon">Trainer Fee</span>
                <input type="number" style="width: 100% !important" required pattern="[0-9]+" autocomplete="off"
                    pInputText placeholder="Price" readonly name="totalTrainerFee" [(ngModel)]="totalTrainerFee"
                    #trainerFee="ngModel" [ngClass]="trainerFee.invalid &&
                    (trainerFee.dirty || trainerFee.touched)
                    ? 'errorInput'
                    : ''" />
                <span class="p-inputgroup-addon">.00</span>
            </div>
            <div *ngIf="trainerFee.invalid &&
                (trainerFee.dirty || trainerFee.touched)">
                <div *ngIf="trainerFee.errors.required" class="errorShow">
                    Please Enter Trainer Fee Correctly.
                </div>
                <div *ngIf="trainerFee.errors.pattern" class="errorShow">
                    Please Enter Trainer Fee Correctly.
                </div>
            </div>
        </div>
        <div class="p-g-12 p-md-12">
            <div class="p-inputgroup"></div>
        </div>

        <p-footer>
            <button (click)="addFee()" style="float: right !important; margin-right: 42px !important;"
                [disabled]="!feeForm.valid" pButton type="button" label="Save" icon="pi pi-save"
                class="p-button-success"></button>
        </p-footer>
    </form>
</p-dialog> -->